import { AppData, Lightning, Registry, Utils } from "@lightningjs/sdk"
import { AppSetup } from "../lib/app-setup"

export interface BackBarTemplateSpec extends Lightning.Component.TemplateSpec {
    BackBar: object
    action: any
}

export default class BackBarUI
    extends Lightning.Component<BackBarTemplateSpec>
    implements Lightning.Component<BackBarTemplateSpec> {
    static override _template(): Lightning.Component.Template<BackBarTemplateSpec> {
        return {
            ...super._template(),
            BackBar: {
                w: 116,
                h: 1080,
                rect: true,
                color: 0xff13132e,
                alpha: 0.83,
                collision: true,
                SquareIcon: {
                    x: 65,
                    y: 70,
                    mount: 0.5,
                },
                Icon: {
                    x: 40,
                    y: (h) => h / 2,
                    zIndex: 62,
                    collision: true,
                    texture: { src: Utils.asset('/images/ico-back.png'), resizeMode: { h: 48, w: 48, type: 'contain' }, type: Lightning.textures.ImageTexture }
                }
            },
        }
    }

    _squareLogo() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        const square_icon = app?.appApiConfig?.appConfig?.square_icon
        this.tag("BackBar.SquareIcon").patch({
            texture: {
                src: square_icon,
                resizeMode: {
                    h: 60,
                    w: 60,
                    type: 'contain'
                },
                type: Lightning.textures.ImageTexture
            }
        })
    }

    override _firstActive() {
        this._squareLogo()
    }

    _handleClick(e) {
        if (e && e.__ref && e.__ref == 'Icon') {
            this.fireAncestors('$handleBackButton');
        }
    }
}